import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {G_SASS_API_URL} from "@gebeya/g-saas-core-mf-shared-ts";
import { ConfigModel } from 'src/app/shared/models/config.model';


const tenant_origin_header_key = 'x-tenant-origin';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private http: HttpClient) {
  }

  getConfig(): Observable<ConfigModel> {
     const url = 'tenants/configuration';
     const fullHostBaseUrl = location.protocol + '//' + location.host;
     const headers = new HttpHeaders().set(tenant_origin_header_key, fullHostBaseUrl );
     return this.http.get<ConfigModel>(`${G_SASS_API_URL}/${url}`, {headers}).pipe(
       map((res:any) => {
         return res.data;
       })
     );


  }
}
